import { useCMSPageField } from '@/cms/fields'
import { BreadcrumbsItemProps, Breadcrumbs as BreadcrumbsPrimitive } from '@sunwebgroup/uds-ui/breadcrumbs'

export default function Breadcrumbs() {
  const breadcrumbsElements = useCMSPageField('Breadcrumb.elements')

  const breadcrumbs
    = breadcrumbsElements?.map(
      e =>
        ({
          href: e.href,
          label: e.text,
          id: e.text,
        } as BreadcrumbsItemProps),
    ) ?? []

  return <BreadcrumbsPrimitive items={breadcrumbs} />
}
